import React, { useState, useEffect } from "react";
import "../../component/css/reports.css";
import profilepic2 from "../../component/images/profilepic2.jpg";
import { useNavigate } from "react-router-dom";
import User_Resolved from "./User_Resolved";
import User_Report from "./User_Report";
import User_Support from "../support/User_Support";
import No_Report from "../../component/notfound/No_Report";
import No_Users_Report from "../../component/notfound/No_Users_Report";
import { ClipLoader } from "react-spinners";

export default function User_Reporttoggle() {
  const [toggle, setToggle] = useState(true);
  const [data, getData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const token = JSON.parse(sessionStorage.getItem("userToken"));
  const [result, setResult] = useState();
  const navigate = useNavigate();

  const firstClick = () => {
    setToggle(true);

    // navigate("/Pending-del");
  };

  const secondClick = () => {
    setToggle(false);
    // navigate("/Pending-del");
  };
  let DATE = {};

  setTimeout(() => {
    setIsLoaded(true);
  }, 3000);

  const TimeConverter = (props) => {
    //console.log(props)
    const date = new Date(props.value);
    DATE = {
      date: date.toLocaleDateString(),
      time: date.toLocaleTimeString(),
      combined: `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`,
    };
    return DATE.time;
  };

  // const fetchData = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://serverpickload.wl.r.appspot.com/admin_reports/users_unresolved",
  //       {
  //         method: "POST",

  //         body: JSON.stringify({
  //           token: token,
  //           pageCount: 1
  //         }),
  //         headers: {
  //           "Content-Type": "application/json",
  //           Accept: "application/json, text/plain, */*"
  //         },
  //       }
  //     )
  //     // getData(await response.json());
  //     const resultM = await response.json();
  //     getData(resultM.reports);
  //     setResult(resultM)
  //     setIsLoaded(true)
  //     //console.log(result);
  //     //console.log(data);

  //     if(response.status === 200) {
  //       //console.log('data gotten succesfully');
  //     } else {
  //       //console.log('some error occurred');
  //     }
  //   } catch(error) {
  //     //console.log(error);
  //   }
  // }

  if (!isLoaded) {
    //console.log('got here')
    return (
      <h1
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ClipLoader color={"#1FAA08"} size={100} />
      </h1>
    );
  } else {
    //console.log('data gotten succesfully');

    return (
      <div className="no-report">
        <div className="reports-switch">
          <div
            className="report4-toggle"
            onClick={firstClick}
            id={toggle ? "active" : "inactive2"}
          >
            {" "}
            Users Unresolved Reports
          </div>
          <div
            className="report5-toggle"
            onClick={secondClick}
            id={toggle ? "inactive" : "active2"}
          >
            {" "}
            Users Resolved Reports
          </div>
        </div>

        {toggle === true ? (
          <User_Report
            click={() => {
              navigate("/App/User_Report");
            }}
          />
        ) : toggle === false ? (
          <User_Resolved
            click2={() => {
              navigate("/App/User_Resolved");
            }}
          />
        ) : null}
      </div>
    );
  }
  // else if (result.msg === 'No user reports available presently'){
  //     //console.log('and here');
  //     return (<No_Users_Report />)
  // }
}
